import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';

@Component({
    selector: 'medpt-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    standalone: false
})
export class ForbiddenComponent implements OnInit {
  dashboardUrl: string = "";
  constructor(private loaderService: LoaderService) {
    this.dashboardUrl = Helpers.getApplicationUrl() + "/Dashboard";
  }

  ngOnInit(): void {
    this.loaderService.hideLoader();
  }

}
